<template>
  <div style="padding: 0 20px 30px">
    <div style="height: 40px">
      <el-button type="primary" size="mini" @click="addFace">绑定门禁</el-button>
    </div>
    <div style="height: 400px">
      <el-table height="100%" :data="faceTable" border style="width: 100%" highlight-current-row>
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="devicesn" label="门禁编号" min-width="130" align="center"></el-table-column>
        <el-table-column prop="name" label="门禁名称" min-width="100" align="center"></el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="scope">
            <i title="解绑" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delDevice(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="openShow" v-if="openShow" width="500px" :show-close="true" :close-on-click-modal="false"
               center append-to-body class="all-open">
      <div class="title-top-alarm">
        <span>录入门禁</span>
        <div class="line-title"></div>
      </div>
      <div style="padding: 30px;box-sizing: border-box">
        <span>门禁：</span>
        <el-select v-fixZoom v-model="deviceid" style="width: 360px;" placeholder="请选择门禁" @change="changetype">
          <el-option v-for="item in faceDevices" :key="item.devicesn" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div style="height: 50px">
        <el-row style="margin: 0 20px">
          <el-col :span="12">
            <div class="cancel-btn" @click="openShow = !openShow"><span>取消</span></div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="submitAdd()"><span>确定</span></div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  facepersondelete,
  facedeviceperson,
  facedevice,
  faceunusedenrollid,
  facepersonadd
} from '../../../api/yanglaoyuan'

export default {
  name: 'faceDeviceList',
  model: {
    prop: 'faceDeviceShow',
    event: 'change'
  },
  props: {
    listObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      allFace: [],
      faceDevices: [],
      deviceid: '',
      device: '',
      faceTable: [],
      openShow: false
    }
  },
  mounted () {
    this.queryDataFaceDevices()
  },
  methods: {
    queryDataFaceDevices () {
      let data = {
        orgid: this.$store.state.user.orgid
      }
      facedevice(data).then(res => {
        this.allFace = res.data.devices
        this.getFaceDeviceByPersonId()
      }).catch(() => {})
    },
    changetype (id) {
      let vm = this
      this.faceDevices.forEach(item => {
        if (item.id === id) {
          vm.device = item
        }
      })
      console.log(this.device)
    },
    getFaceDeviceByPersonId () {
      let data = {
        orgid: this.$store.state.user.orgid,
        personid: this.listObj.row.epid
      }
      facedeviceperson(data).then(res => {
        this.faceTable = res.data.devices
        let ids = []
        let list = []
        res.data.devices.forEach(item => {
          ids.push(item.id)
        })
        this.allFace.forEach(item => {
          if (ids.indexOf(item.id) === -1) {
            list.push(item)
          }
        })
        this.faceDevices = list
        this.deviceid = ''
        this.device = ''
      }).catch(() => {})
    },

    addFace () {
      if (this.listObj.row.photo_url === '') {
        this.$message({ message: '该人员暂无头像上传，请先上传头像。', type: 'warning' })
        return
      }
      if (this.faceDevices.length === 0) {
        this.$message({ message: '该人员暂无门禁可绑定。', type: 'warning' })
        return
      }
      this.openShow = true
    },
    submitAdd () {
      if (this.deviceid === '') {
        this.$message({ message: '请选择门禁', type: 'warning' })
      } else {
        this.getenrollidlist()
      }
    },
    getenrollidlist () {
      let data = {
        deviceid: this.device.id,
        count: 1
      }
      faceunusedenrollid(data).then(res => {
        if (res.data.enrollids.length > 0) {
          this.getData(this.listObj.row.photo_url, res.data.enrollids)
        }
      }).catch(() => {})
    },
    async getData (url, arr) {
      let listUrl = []
      let vm = this
      await this.convertImageToBase64(url, base64 => {
        console.log(base64) // 输出图片的Base64编码
        listUrl = base64.split('base64,')
        console.log(listUrl)
        // return listUrl
        vm.endSend(arr[0], listUrl[1])
      })
    },
    async endSend (enrollid, record) {
      let data = {
        devicesn: this.device.devicesn,
        enrollid: enrollid,
        name: this.listObj.row.person_name,
        backupnum: 50,
        admin: 0,
        personid: this.listObj.row.epid,
        staffid: 0,
        record: record
      }
      await facepersonadd(data).then(res => {
        this.$message({ type: 'success', message: '成功绑定门禁', duration: 500 })
        this.getFaceDeviceByPersonId()
        this.openShow = false
      }).catch(() => {})
    },
    async convertImageToBase64 (url, callback) {
      await fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const reader = new FileReader()
          reader.onload = e => callback(e.target.result)
          reader.readAsDataURL(blob)
        })
        .catch(error => console.error('Error converting image to Base64:', error))
    },

    delDevice (row) {
      let data = {
        deviceid: row.id,
        enrollid: row.enrollid,
        personid: this.listObj.row.epid,
        staffid: ''
      }
      facepersondelete(data).then(res => {
        if (this.personTable.length === 1 && this.currentPage > 1) {
          this.currentPage--
        }
        this.$notify({title: '成功', message: '删除成功', type: 'success', duration: 2000})
        this.getPersonList()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/faceDeviceList.vue